import { Col } from "antd";
import { DetailStatisticCard } from "./DetailStatisticCard";
import { FilesIcon } from "@phosphor-icons/react";
import { useCustom, useTranslate } from "@refinedev/core";
import { useSearchParams } from "react-router-dom";
import { DocumentSummaryStats } from "types/";
import { ANALYTICS_STALE_TIME, TARGETS } from "./constants/constants";
import { analyticsTheme } from "./analyticsTheme";
import { useAnalyticsBackState } from "../../projects/hooks/useAnalyticsBack";

const T_PREFIX =
  "media.projects.analytics.dashboard.summaryCards.documentHighlighter";

interface DocumentSummaryProps {
  projectId: string;
}

export const DocumentSummary: React.FC<DocumentSummaryProps> = ({
  projectId,
}) => {
  const t = useTranslate();
  const [searchParams] = useSearchParams();
  const backState = useAnalyticsBackState();
  const {
    data: documentSummary,
    isLoading: isDocumentSummaryLoading,
    isFetching: isDocumentSummaryFetching,
  } = useCustom<DocumentSummaryStats>({
    url: `analytics/projects/${projectId}/analytics/document/summary`,
    method: "get",
    queryOptions: {
      enabled: !!projectId,
      staleTime: ANALYTICS_STALE_TIME,
    },
    errorNotification: false,
  });

  const documentData = documentSummary?.data;

  return (
    <Col sm={24} md={8}>
      <DetailStatisticCard
        icon={<FilesIcon size={18} weight="fill" />}
        iconColor={analyticsTheme.datasetAmber}
        title={t(`${T_PREFIX}.title`).toUpperCase()}
        loading={isDocumentSummaryLoading || isDocumentSummaryFetching}
        metrics={[
          {
            title: t(`${T_PREFIX}.avgReadDepth`).toUpperCase(),
            metric: documentData?.avg_reading_depth_pct,
            type: "percentage",
            target: TARGETS.documentHighlighter.avg_reading_depth_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.scrollRate`).toUpperCase(),
            metric: documentData?.scroll_rate_pct,
            type: "percentage",
            target: TARGETS.documentHighlighter.scroll_rate_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.fullCompleters`).toUpperCase(),
            metric: documentData?.full_completers_pct,
            type: "percentage",
            target: TARGETS.documentHighlighter.full_completers_pct,
            aim: "high",
          },
          {
            title: t(`${T_PREFIX}.backtrackRate`).toUpperCase(),
            metric: documentData?.backtrack_rate_pct,
            type: "percentage",
            target: TARGETS.documentHighlighter.backtrack_rate_pct,
            aim: "low",
          },
        ]}
        to={`./document-highlighter?${searchParams.toString()}`}
        replace
        state={backState}
        className={"document-highlighter-card"}
      />
    </Col>
  );
};
